module.exports = __webpack_public_path__ + "img/img14.68de0f9d.svg";